const Input = ({ type, className }) => {
  return <input className={className} type={type} placeholder={type} />;
};

export default Input;
